import { render, staticRenderFns } from "./PrivacyStatus.vue?vue&type=template&id=38f7a030&scoped=true"
import script from "./PrivacyStatus.vue?vue&type=script&lang=js"
export * from "./PrivacyStatus.vue?vue&type=script&lang=js"
import style0 from "./PrivacyStatus.vue?vue&type=style&index=0&id=38f7a030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7a030",
  null
  
)

export default component.exports